import PropTypes from 'prop-types'
import { Component } from 'react'
import { FormattedMessage } from 'react-intl'

import Button from '@/components/Button'
import Card from '@/components/Card'
import Textarea from '@/components/Form/Textarea'
import KeyValue from '@/components/KeyValue'
import { getIdpName } from '@/pages/OrganizationSecurityPage/utils'

import messages from './messages'

class ViewSamlIdentityProvider extends Component<any, any> {
  static displayName = 'ViewSamlIdentityProvider'

  static propTypes = {
    identityProvider: PropTypes.shape({
      id: PropTypes.string.isRequired,
      idpName: PropTypes.string.isRequired,
      metadata: PropTypes.string.isRequired,
      emailAttribute: PropTypes.string.isRequired,
      usernameAttribute: PropTypes.string.isRequired,
      familyNameAttribute: PropTypes.string.isRequired,
      idpDomains: PropTypes.array.isRequired
    }).isRequired,
    onEdit: PropTypes.func.isRequired
  }

  onEdit = () => {
    this.props.onEdit()
  }

  render() {
    const { identityProvider } = this.props
    return (
      <Card>
        <Card.Header title={<FormattedMessage {...messages.cardTitle} />}>
          <Button color="primary" onClick={this.onEdit}>
            <FormattedMessage {...messages.edit} />
          </Button>
        </Card.Header>

        <KeyValue>
          <KeyValue.Label>
            <FormattedMessage {...messages.identityProvider} />
          </KeyValue.Label>
          <KeyValue.Value>{getIdpName(identityProvider.idpName)}</KeyValue.Value>
        </KeyValue>

        <Textarea
          readOnly={true}
          label={<FormattedMessage {...messages.metadata} />}
          name="metadata"
          value={identityProvider.metadata}
          rows={15}
        />

        <KeyValue>
          <KeyValue.Label>
            <FormattedMessage {...messages.emailAttribute} />
          </KeyValue.Label>
          <KeyValue.Value>{identityProvider.emailAttribute}</KeyValue.Value>
        </KeyValue>
        <KeyValue>
          <KeyValue.Label>
            <FormattedMessage {...messages.usernameAttribute} />
          </KeyValue.Label>
          <KeyValue.Value>{identityProvider.usernameAttribute}</KeyValue.Value>
        </KeyValue>
        <KeyValue>
          <KeyValue.Label>
            <FormattedMessage {...messages.familyNameAttribute} />
          </KeyValue.Label>
          <KeyValue.Value>{identityProvider.familyNameAttribute}</KeyValue.Value>
        </KeyValue>
      </Card>
    )
  }
}

export default ViewSamlIdentityProvider
